import { render, staticRenderFns } from "./ExpenseCategoryWidget.vue?vue&type=template&id=265654af&scoped=true"
import script from "./ExpenseCategoryWidget.vue?vue&type=script&lang=ts"
export * from "./ExpenseCategoryWidget.vue?vue&type=script&lang=ts"
import style0 from "./ExpenseCategoryWidget.vue?vue&type=style&index=0&id=265654af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265654af",
  null
  
)

export default component.exports